module.exports = __webpack_public_path__ + "img/img_01.521b60c3.jpg";